import axios, { AxiosError, AxiosResponse } from "axios";
import { messagesError } from "./messages.services";
import { Headers } from "./http.services";
import { DataResponse } from "../../shared/interface/data-response";
import { FormDynamic } from "../../shared/interface/form-dynamic";
import { UserCognito } from "../../shared/interface/users";

class ApiServices {
  public endpoint: string | undefined;
  constructor() {
    this.endpoint = process.env.REACT_APP_ENDPOINT_BASE;
  }

  public async getForms(): Promise<DataResponse<FormDynamic[]>> {
    return axios
      .get(`${this.endpoint}/forms/all`, Headers)
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        messagesError(error);
      });
  }

  public async getFormsId(id: string): Promise<DataResponse<FormDynamic>> {
    return axios
      .get(`${this.endpoint}/forms/${id}`, Headers)
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        messagesError(error);
      });
  }

  public async saveForm(payload: FormDynamic): Promise<DataResponse<FormDynamic>> {
    return axios
      .post(`${this.endpoint}/forms`, payload, Headers)
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        messagesError(error);
      });
  }

  public async getFields(): Promise<DataResponse<FormDynamic[]>> {
    return axios
      .get(`${this.endpoint}/fields/all`, Headers)
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        messagesError(error);
      });
  }

  public async getUsers(cantidad: string): Promise<DataResponse<UserCognito>> {
    return axios
      .get(`${this.endpoint}/cognito/users/${cantidad}`, Headers)
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        messagesError(error);
      });
  }
}

export const Api = new ApiServices();
